import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";

const WhoAreWeLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Grid
                    direction={{xs: 'column-reverse', md: 'row'}}
                    justifyContent='center'
                    alignItems='center'
                    container
                    width='100%'
                    px='5%'
                    spacing={{xs: 4, md: 5}}
                >
                    <Grid size={{xs: 12, md: 6}}>
                        <Stack
                            direction='column'
                            justifyContent='center'
                            alignItems='start'
                            spacing={{xs: 0, md: 4}}
                        >
                            <TitleComponent 
                                title={t('about.title')}
                                removePadding
                            />

                            <Typography
                                fontWeight={500}
                                fontSize={{xs: 12, md: 12, lg: 16}}
                                textAlign={{xs: 'center', md: 'justify'}}
                                lineHeight={{xs: 1.5, md: 2}}
                                color={theme.palette.text.secondary}
                            >
                                {t('about.description')}
                            </Typography>
                        </Stack>
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <img 
                            src="/images/about/aboutus.png" 
                            alt="about us" 
                            width='100%'
                            style={{
                                borderRadius: 32
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default WhoAreWeLayout;